import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms'; 
import { Router, RouterLink, ActivatedRoute  } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AuthService } from '../../core/services/auth.service';
import { RegisterPayload, AuthResponse } from '../../core/models/auth.model'; 

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    TranslateModule
  ],
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent {

  registerData = {
    name: '',         
    address: '',      
    email: '',
    password: '',
    confirmPassword: '' 
  };
  showPassword = false;
  showConfirmPassword = false;
  registrationError: string | null = null;
  registrationSuccess: string | null = null;
  isLoading = false;

  isNameDisabled = false;
  isEmailDisabled = false;
  constructor(
    private router: Router,
    private translate: TranslateService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef
  ) {}
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => { 
      if (params['email']) { //
        this.registerData.email = params['email']; 
        this.isEmailDisabled = true; 
        console.log('从 URL 获取到邮箱:', this.registerData.email);
      }
      if (params['school_name']) { 
        this.registerData.name = decodeURIComponent(params['school_name']); 
        this.isNameDisabled = true;
        console.log('从 URL 获取到学校名称:', this.registerData.name); 
      }
      this.cdRef.detectChanges(); 
    });
  }
  toggleShowPassword(): void {
    this.showPassword = !this.showPassword;
  }

  toggleShowConfirmPassword(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  onRegister(form: NgForm): void { 
    this.registrationError = null;
    this.registrationSuccess = null;
    // this.router.navigate(['/information-school-enrollment']);
    if (form.invalid) {
      this.registrationError = this.translate.instant('VALIDATION.FORM_INVALID'); 
      return;
    }


    if (this.registerData.password !== this.registerData.confirmPassword) {
      this.registrationError = this.translate.instant('REGISTER.PASSWORD_MISMATCH'); 
      return;
    }

    this.isLoading = true; 

    const payload: RegisterPayload = {
      name: this.registerData.name,
      address: this.registerData.address,
      email: this.registerData.email,
      password: this.registerData.password,
      password_confirmation: this.registerData.confirmPassword 
    };

    this.authService.register(payload).subscribe({
      next: (response: AuthResponse) => {
        this.isLoading = false; 
        if (response.status === 'ok' && response.school) {
          this.registrationSuccess = 'REGISTER.REGISTRATION_SUCCESSFUL'; 
          console.log('注册成功:', response.school);
          setTimeout(() => {
            // this.router.navigate(['/login']);
            this.router.navigate(['/schoolEnrollmentForm']);
          }, 2500); 
        } else {
          console.error('API 注册失败:', response.errors || response.message);
          if (response.errors) {
            const errorMessages: string[] = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key) && Array.isArray(response.errors[key])) {
                errorMessages.push(...response.errors[key]);
              }
            }
            this.registrationError = errorMessages.join(' '); 
          } else if (response.message) {
            this.registrationError = response.message; 
          } else {
            this.registrationError = this.translate.instant('REGISTER.REGISTRATION_FAILED');
          }
        }
      },
      error: (errorResponse) => { 
        this.isLoading = false; 
        console.error('注册 HTTP 请求错误:', errorResponse);
        if (errorResponse.error && typeof errorResponse.error === 'object') {
          const backendError = errorResponse.error;
          if (backendError.errors) {
            const errorMessages: string[] = [];
            for (const key in backendError.errors) {
              if (backendError.errors.hasOwnProperty(key) && Array.isArray(backendError.errors[key])) {
                errorMessages.push(...backendError.errors[key]);
              }
            }
            this.registrationError = errorMessages.join(' ');
          } else if (backendError.message) {
            this.registrationError = backendError.message;
          } else {
            this.registrationError = this.translate.instant('REGISTER.REGISTRATION_FAILED');
          }
        } else if (typeof errorResponse.message === 'string' && errorResponse.message) {
            this.registrationError = errorResponse.message;
        }
        else {
          this.registrationError = this.translate.instant('REGISTER.REGISTRATION_FAILED');
        }
      }
    });
  }
}